import Model from './model'

export default class NavItem extends Model {
  constructor() {
    super()
    this.hydrate({
      sort: '',
      title: '',
      active: '',
      page_id: '',
      parent_id: '',
      children: []
    })
  }
}
